const familiaresInitialState = {
    familiares: {
      loading: false,
      error: null,
      data: null,
    },
  };
  
  export default familiaresInitialState;
  